import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshIcon } from './icons';

interface Props {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  action?: React.ReactNode;
  subtitle?: string;
  onRefresh?: () => void;
  isRefreshing?: boolean;
  showLogo?: boolean;
}

function BackIcon() {
  return (
    <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  );
}

export function PageHeader({ title, showBack = false, onBack, action, subtitle, onRefresh, isRefreshing = false, showLogo = false }: Props) {
  const navigate = useNavigate();

  const handleBack = onBack ?? (() => navigate(-1));

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200">
      <div
        className="flex items-center h-14 px-4 gap-3"
        style={{ paddingTop: 'env(safe-area-inset-top)' }}
      >
        {showBack && (
          <button
            onClick={handleBack}
            className="flex items-center justify-center w-10 h-10 -ml-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors touch-manipulation"
            aria-label="Voltar"
          >
            <BackIcon />
          </button>
        )}
        {showLogo && (
          <img
            src="/home-stock-transp-256x256.png"
            alt=""
            className="w-7 h-7 flex-shrink-0 -ml-0.5"
          />
        )}
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-bold text-gray-900 truncate leading-tight">{title}</h1>
          {subtitle && <p className="text-xs text-gray-500 truncate">{subtitle}</p>}
        </div>
        {onRefresh && (
          <button
            onClick={onRefresh}
            disabled={isRefreshing}
            className="flex items-center justify-center w-10 h-10 rounded-xl text-gray-500 hover:bg-gray-100 transition-colors touch-manipulation disabled:opacity-50"
            aria-label="Atualizar"
          >
            <RefreshIcon size={18} className={isRefreshing ? 'animate-spin' : ''} />
          </button>
        )}
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
    </header>
  );
}
